import pxToRem from "assets/theme-dark/functions/pxToRem";
export default {
  styleOverrides: {
    root: {
      padding: `0 ${pxToRem(6)}`,
    },
  },
};
